import interopRequireDefault from "@babel/runtime/helpers/interopRequireDefault"
const clientGlobalObject = ((() => {
    const globalObject = [() => window, () => global, () => self].reduce(
      (acc, recognizer) => {
        try {
          return acc != null ? acc : recognizer()
        } catch(e) {}
      },
      null
    )
    
    if (globalObject == null) {
      throw new Error('Client global object recognition failed')
    }

    if(true) {
      return globalObject
    }

    const key = undefined
    if(globalObject[key] == null) {
      throw new Error(`Client global key ${key} object recognition failed`)
    }
  
    return globalObject[key]
  })())
const defaultRuntimeEnv = {}
Object.defineProperty(
        defaultRuntimeEnv,
        "MYSQL_HOST",
        {
          enumerable: true,
          value: "localhost"
        }
      )
Object.defineProperty(
        defaultRuntimeEnv,
        "MYSQL_PORT",
        {
          enumerable: true,
          value: "3306"
        }
      )
Object.defineProperty(
        defaultRuntimeEnv,
        "MYSQL_USER",
        {
          enumerable: true,
          value: "customUser"
        }
      )
Object.defineProperty(
        defaultRuntimeEnv,
        "MYSQL_PASSWORD",
        {
          enumerable: true,
          value: "customPassword"
        }
      )
Object.defineProperty(
        defaultRuntimeEnv,
        "MYSQL_DBNAME",
        {
          enumerable: true,
          value: "readmodels"
        }
      )
Object.defineProperty(
        defaultRuntimeEnv,
        "HOST",
        {
          enumerable: true,
          value: "localhost"
        }
      )
Object.defineProperty(
        defaultRuntimeEnv,
        "PORT",
        {
          enumerable: true,
          value: "3000"
        }
      )
Object.defineProperty(
        defaultRuntimeEnv,
        "EVENTSTORE_MYSQL_HOST",
        {
          enumerable: true,
          value: "localhost"
        }
      )
Object.defineProperty(
        defaultRuntimeEnv,
        "EVENTSTORE_MYSQL_PORT",
        {
          enumerable: true,
          value: "3306"
        }
      )
Object.defineProperty(
        defaultRuntimeEnv,
        "EVENTSTORE_MYSQL_USER",
        {
          enumerable: true,
          value: "customUser"
        }
      )
Object.defineProperty(
        defaultRuntimeEnv,
        "EVENTSTORE_MYSQL_PASSWORD",
        {
          enumerable: true,
          value: "customPassword"
        }
      )
Object.defineProperty(
        defaultRuntimeEnv,
        "EVENTSTORE_MYSQL_DBNAME",
        {
          enumerable: true,
          value: "events"
        }
      )

    if(clientGlobalObject.__RESOLVE_RUNTIME_ENV__ == null) {
      clientGlobalObject.__RESOLVE_RUNTIME_ENV__ = defaultRuntimeEnv
      try {
        if(window == null || clientGlobalObject !== window) {
          throw new Error('Skip warning')
        }
        console.warn(`
          Client-runtime variables have been set to default values since __RESOLVE_RUNTIME_ENV__ is not defined
        `)
      } catch(e) {}
    }
  
const clientChunk = {
  clientImports: interopRequireDefault(require('$resolve.clientImports')).default,
  viewModels: interopRequireDefault(require('$resolve.viewModels')).default,
  rootPath: interopRequireDefault(require('$resolve.rootPath')).default,
  staticPath: interopRequireDefault(require('$resolve.staticPath')).default,
  jwtCookie: interopRequireDefault(require('$resolve.jwtCookie')).default,
  applicationName: interopRequireDefault(require('$resolve.applicationName')).default,
  subscriber: interopRequireDefault(require('@resolve-js/client/lib/subscribe-adapter')).default,
  customConstants: interopRequireDefault(require('$resolve.customConstants')).default,
  cdnUrl: interopRequireDefault(require('$resolve.cdnUrl')).default
}
export default clientChunk